import { registerActivity } from "../registry";
import { WorkflowActivityDefinition } from "../types";

export const Filter: WorkflowActivityDefinition = {
  group: 'internal',
  name: 'filter',
  type: 'activity',
  schema: {
    type: 'object',
    properties: {
      query: {
        title: 'Query',
        type: 'object',
      },
    },
  },
  defaults: {
    query: {
      combinator: "and",
      rules: [
      ],
    },
  },
};

registerActivity(Filter);
